import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, Trophy } from 'lucide-react';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const CreateTournamentPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    name: '',
    gender: 'M',
    registration_deadline: '',
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) { toast.error('Inserisci il nome del torneo'); return; }
    setLoading(true);
    try {
      const res = await axios.post(`${API_URL}/api/tournaments`, form, { withCredentials: true });
      toast.success('Torneo creato!');
      navigate(`/tournaments/${res.data.tournament_id}`);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Errore nella creazione');
    } finally { setLoading(false); }
  };

  return (
    <div className="p-4 sm:p-6 lg:p-8 max-w-lg mx-auto animate-fadeIn" data-testid="create-tournament-page">
      <div className="flex items-center gap-4 mb-8">
        <button onClick={() => navigate(-1)} className="w-10 h-10 flex items-center justify-center rounded-full bg-white border border-slate-200 hover:bg-slate-50">
          <ArrowLeft className="w-5 h-5 text-slate-600" />
        </button>
        <h1 className="font-outfit text-2xl font-semibold text-slate-900">Nuovo Torneo</h1>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="bg-white rounded-3xl p-6 border border-slate-100">
          <label className="block text-sm font-medium text-slate-700 mb-3">
            <Trophy className="w-4 h-4 inline mr-2" />
            Nome Torneo
          </label>
          <input
            type="text"
            value={form.name}
            onChange={(e) => setForm(prev => ({ ...prev, name: e.target.value }))}
            data-testid="tournament-name-input"
            className="w-full px-4 py-3 rounded-2xl border border-slate-200 bg-slate-50 focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-400/20 transition-all outline-none"
            placeholder="es. Torneo di Primavera 2026"
            required
          />
        </div>

        <div className="bg-white rounded-3xl p-6 border border-slate-100">
          <label className="block text-sm font-medium text-slate-700 mb-3">Categoria</label>
          <div className="flex gap-3">
            {[{ v: 'M', l: 'Maschile' }, { v: 'F', l: 'Femminile' }].map((opt) => (
              <button
                key={opt.v}
                type="button"
                onClick={() => setForm(prev => ({ ...prev, gender: opt.v }))}
                data-testid={`gender-${opt.v}`}
                className={`flex-1 px-4 py-3 rounded-2xl text-center font-medium transition-all ${
                  form.gender === opt.v
                    ? 'bg-amber-500 text-white'
                    : 'bg-slate-50 text-slate-600 hover:bg-slate-100 border border-slate-200'
                }`}
              >
                {opt.l}
              </button>
            ))}
          </div>
        </div>

        <div className="bg-white rounded-3xl p-6 border border-slate-100">
          <label className="block text-sm font-medium text-slate-700 mb-3">Scadenza Iscrizioni (opzionale)</label>
          <input
            type="date"
            value={form.registration_deadline}
            onChange={(e) => setForm(prev => ({ ...prev, registration_deadline: e.target.value }))}
            data-testid="tournament-deadline-input"
            className="w-full px-4 py-3 rounded-2xl border border-slate-200 bg-slate-50 focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-400/20 transition-all outline-none"
          />
        </div>

        <div className="bg-amber-50 rounded-2xl p-4 border border-amber-200">
          <h4 className="font-medium text-amber-800 text-sm mb-2">Regole Torneo</h4>
          <ul className="text-xs text-amber-700 space-y-1">
            <li>Eliminazione diretta con tabellone ATP-style (seed per ranking)</li>
            <li>Giocatori entro ±2 fasce di livello</li>
            <li>Le partite contano nel ranking dinamico</li>
            <li>Bonus Vincitore: +500 punti</li>
            <li>Bonus Finalista: +200 punti</li>
          </ul>
        </div>

        <button
          type="submit"
          disabled={loading}
          data-testid="submit-tournament-btn"
          className="w-full py-4 bg-amber-500 text-white rounded-full font-medium text-lg hover:bg-amber-600 transition-all disabled:opacity-50 flex items-center justify-center gap-2"
        >
          {loading ? (
            <div className="w-6 h-6 border-2 border-white/30 border-t-white rounded-full animate-spin" />
          ) : (
            <>
              <Trophy className="w-5 h-5" />
              Crea Torneo
            </>
          )}
        </button>
      </form>
    </div>
  );
};

export default CreateTournamentPage;
